import React from 'react';
import confetti from 'canvas-confetti';

interface IConfettiEffect {
  title: string | number | React.ReactNode;
}

export const ConfettiEffect = ({ title }: IConfettiEffect) => {
  const fireConfetti = () => {
    confetti({
      particleCount: 1000,
      spread: 360,
      origin: { y: 0.5 }
    });
  };

  return (
    <button onClick={fireConfetti} className='font-bold' aria-label='Click me to revel surprise'>
      <span>{title}</span>
    </button>
  );
};
